export default ({ request }) => ({
  rptCostDetailListApi(data = {}) {
    return request({
      url: '/financial/rpt/cost/detail/list',
      method: 'POST',
      data,
    })
  },
})
